












import SearchResultCard from '@/components/search/SearchResultCard.vue';
import container from '@/model/ModelContainer';
import ISearchState from '@/model/state/search/ISearchState';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
        SearchResultCard,
    },
})
export default class SearchResult extends Vue {
    public searchState: ISearchState = container.get<ISearchState>('ISearchState');

    public jumpResultOption(): void {
        this.$emit('ruleOption');
    }
}
